/**
 * Normalizes the Smartico store response to a flat item array. The SDK resolves
 * an envelope `{ items, errCode, ... }` (and pushes the same shape through
 * `onUpdate`), not a bare array, so read `.items`. Tolerates either shape.
 */
const toItems = response => {
  if (Array.isArray(response)) return response;
  if (response && Array.isArray(response.items)) return response.items;
  return [];
};

/**
 * Smartico Store widget accessor. `getStoreItems({ onUpdate })` resolves the
 * initial catalog and invokes `onUpdate` with the full replacement catalog on
 * every refresh (e.g. after a purchase). Resolves to an empty array when the
 * Smartico API is unavailable so callers fall through to the empty state.
 */
export const getStoreItems = async ({ onUpdate = () => {} } = {}) => {
  if (!window._smartico?.api) {
    return [];
  }

  const response = await window._smartico.api.getStoreItems({
    onUpdate: payload => onUpdate(toItems(payload)),
  });

  return toItems(response);
};
